import React from 'react';
import { motion } from 'framer-motion';
import { CalendarIcon } from 'lucide-react';
import { trackPixelEvent } from '../utils/trackPixelEvent';
export function FinalCTASection() {
  return <section className="py-32 bg-tcp-black relative overflow-hidden pt-[35px] pb-[35px]" data-id="element-28">
      {/* Decorative Background */}
      <div className="absolute inset-0 z-0 opacity-30 pointer-events-none" data-id="element-29">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-tcp-red blur-[200px] opacity-20" data-id="element-30" />
      </div>

      <div className="container mx-auto px-6 max-w-4xl relative z-10 text-center" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="border border-white/10 bg-tcp-pure-black/80 backdrop-blur-sm p-12 md:p-20 relative" data-id="element-32">
          {/* Accent corners */}
          <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-tcp-red" data-id="element-33" />
          <div className="absolute top-0 right-0 w-8 h-8 border-t-2 border-r-2 border-tcp-red" data-id="element-34" />
          <div className="absolute bottom-0 left-0 w-8 h-8 border-b-2 border-l-2 border-tcp-red" data-id="element-35" />
          <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-tcp-red" data-id="element-36" />

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-tcp-red/10 text-tcp-red border border-tcp-red/20 mb-8" data-id="element-37">
            <CalendarIcon size={16} data-id="element-38" />
            <span className="text-sm font-semibold uppercase tracking-wider" data-id="element-39">
              Now booking 2026 holiday allocations
            </span>
          </div>

          <h2 className="font-display md:text-6xl font-bold text-white mb-6 text-[32px]" data-id="element-40">
            Sell the Décor Retailers Have Trusted for 35 Years
          </h2>

          <p className="text-gray-400 mb-12 max-w-2xl mx-auto text-[16px]" data-id="element-41">
            Create your wholesale account and get first access to the products,
            pricing, and allocation that move every season.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-42">
            <motion.a href="https://wholesale.thechristmaspalace.com/pages/apply" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.02,
            boxShadow: '0 0 20px rgba(183, 29, 35, 0.4)'
          }} whileTap={{
            scale: 0.98
          }} onClick={() => trackPixelEvent('Lead', {
            content_name: 'Apply Wholesale - Final CTA'
          })} className="w-full sm:w-auto bg-tcp-red hover:bg-tcp-dark-red text-white px-8 py-4 rounded-sm font-medium transition-colors duration-300 uppercase tracking-wide text-[12px] inline-block text-center" data-id="element-43">
              Apply For Your Wholesale Account
            </motion.a>
          </div>
        </motion.div>
      </div>
    </section>;
}